import {OcListElementType, OcListMapType, OcSearchParamType} from "../interface";
import PaginationSub from "../../../../../components/common/pagination/PaginationSub";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import {Dispatch, SetStateAction} from "react";
import FileUploadNoText from "../../../../../components/common/fileUpload/fileUploadNoText/FileUploadNoText";
import {useUploadOverseasExcel} from "../hooks/useUploadOverseasExcel";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import {useExportOverseasStandardFormExcel} from "../hooks/useExportOverseasStandardFormExcel";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

interface PropsType {
    oc: OcListMapType
    searchParam: OcSearchParamType
    setSearchParam: Dispatch<SetStateAction<OcSearchParamType>>
    selectedItem: number[]
    setSelectedItem: Dispatch<SetStateAction<number[]>>
}

export default function List({
                                 oc,
                                 searchParam,
                                 setSearchParam,
                                 selectedItem,
                                 setSelectedItem,
                             }: PropsType) {
    const {goToNavigation} = useGoToNavigation();

    const dataList = oc.overseasVOList ?? []
    const hiddenColumnData = oc.overseasViewInfoVOList ?? []
    const totalCount = oc.totalCount ?? 0

    const colRenderer = () => {
        const xs = {width: "3%", minWidth: "60px"}
        const sm = {width: "6%", minWidth: "120px"}
        const md = {width: "9%", minWidth: "180px"}
        const lg = {width: "12%", minWidth: "240px"}
        const xl = {width: "15%", minWidth: "300px"}
        const auto = {width: "auto", minWidth: "360px"}

        return hiddenColumnData.map(el => {
            if (el.isHidden === "N") {
                switch (el.overseasViewInfoId) {
                    case 1:
                        return <col style={xs}/> // year
                    case 2:
                        return <col style={sm}/> // salesOutDate
                    case 3:
                        return <col style={xs}/> // region
                    case 4:
                        return <col style={xs}/> // country
                    case 5:
                        return <col style={md}/> // customer
                    case 6:
                        return <col style={sm}/> // application
                    case 7:
                        return <col style={sm}/> // product
                    case 8:
                        return <col style={auto}/> // productName
                    case 9:
                        return <col style={sm}/> // msProductCode
                    case 10:
                        return <col style={xs}/> // quantity
                    case 11:
                        return <col style={sm}/> // unitPriceInr
                    case 12:
                        return <col style={sm}/> // unitPriceUsd
                    case 13:
                        return <col style={sm}/> // salesRevenueInr
                    case 14:
                        return <col style={sm}/> // salesRevenueUsd
                    case 15:
                        return <col style={sm}/> // exchangeRate
                    case 16:
                        return <col style={sm}/> // salesRevenueWon
                    case 17:
                        return <col style={auto}/> // remark
                    case 18:
                        return <col style={auto}/> // projectInformation
                    case 19:
                        return <col style={sm}/> // invoicedDate
                    default:
                        return <col style={auto}/>
                }
            }
        })
    }

    const thRenderer = () => {
        return hiddenColumnData.map(el => el.isHidden === "N" && <th>
            {(() => {
                switch (el.overseasViewInfoId) {
                    case 11:
                        return "Unit Price(KRW)"
                    case 13:
                        return "Sales Revenue(KRW)"
                    default:
                        return el.target
                }
            })()}
        </th>)
    }

    const tdRenderer = (idx: number) => {
        const editedHiddenColumnData = hiddenColumnData.map(el => {
            switch (el.overseasViewInfoId) {
                case 1:
                    return {...el, key: "year", className: "text-center"};
                case 2:
                    return {...el, key: "salesOutDate", className: "text-center"};
                case 3:
                    return {...el, key: "region", className: "text-center"};
                case 4:
                    return {...el, key: "country", className: "text-center"};
                case 5:
                    return {...el, key: "customer", className: ""};
                case 6:
                    return {...el, key: "application", className: ""};
                case 7:
                    return {...el, key: "product", className: ""};
                case 8:
                    return {...el, key: "productName", className: ""};
                case 9:
                    return {...el, key: "msProductCode", className: ""};
                case 10:
                    return {...el, key: "quantity", className: "text-center"};
                case 11:
                    return {...el, key: "unitPriceInr", className: "text-center"};
                case 12:
                    return {...el, key: "unitPriceUsd", className: "text-center"};
                case 13:
                    return {...el, key: "salesRevenueInr", className: "text-center"};
                case 14:
                    return {...el, key: "salesRevenueUsd", className: "text-center"};
                case 15:
                    return {...el, key: "exchangeRate", className: "text-center"};
                case 16:
                    return {...el, key: "salesRevenueWon", className: "text-center"};
                case 17:
                    return {...el, key: "remark", className: ""};
                case 18:
                    return {...el, key: "projectInformation", className: ""};
                case 19:
                    return {...el, key: "invoicedDate", className: "text-center"}
                default:
                    return {...el, key: "", className: ""}
            }
        })

        const formatValue = (key: string, value: any) => {
            const numericKeys = [
                "quantity",
                "unitPriceInr",
                "unitPriceUsd",
                "salesRevenueInr",
                "salesRevenueUsd",
                "exchangeRate",
                "salesRevenueWon"
            ];
            if (numericKeys.includes(key) && value !== null && value !== undefined && !isNaN(value)) {
                const num = Number(value);
                return <DisplayNumber value={num}/>
            }
            return value;
        };

        return editedHiddenColumnData.map(el =>
                el.isHidden === "N" && (
                    <td className={el.className}>
                        {formatValue(el.key, dataList.at(idx)?.[el.key as keyof OcListElementType])}
                    </td>
                )
        );
        /*
        return editedHiddenColumnData.map(el => el.isHidden === "N" && <td className={el.className}>
            {dataList.at(idx)?.[el.key as keyof OcListElementType]}
        </td>)
        * */
    }

    const isAllCheck = dataList.length !== 0 && dataList.every(el => selectedItem.includes(el.overseasId))

    const clickAllCheck = () => {
        if (isAllCheck) {
            const list = selectedItem.filter(el => !dataList.map(el => el.overseasId).includes(el))

            setSelectedItem(list)
        } else {
            // @ts-ignore
            const list = [...new Set([...selectedItem, ...dataList.map(el => el.overseasId)])]

            setSelectedItem(list)
        }
    }

    const clickCheck = (el: number) => {
        if (selectedItem.includes(el)) {
            const list = selectedItem.filter(el2 => el !== el2)

            setSelectedItem(list)
        } else {
            setSelectedItem([...selectedItem, el])
        }
    }

    const {mutate: mutateExportOverseasStandardFormExcel} = useExportOverseasStandardFormExcel()
    // const {mutate: mutateExportOverseasExcel} = useExportOverseasExcel()
    const {mutate: mutateUploadOverseasExcel} = useUploadOverseasExcel()

    const btnImportExcel = (file: File[]) => {
        const fd = new FormData()
        file.map(el => fd.append("excelFile", el))

        mutateUploadOverseasExcel(fd)
    }

    const btnExportExcel = () => {
        mutateExportOverseasStandardFormExcel({...searchParam, limit: 1000000})
    }

    const btnGoToColumnSetting = () => {
        goToNavigation("main/overseas/column", {}, false)
    }

    return <div className="content_wrap">
        <div className="table_top">
            <h6 className="table_stats">해외법인 목록(<span>{totalCount}</span>건)</h6>
            <div className="table_toolbar">
                <AuthorityChecker authorityNames={['overseasWriteYn']}>
                    <FileUploadNoText
                        addFileCallback={(file: File[]) => btnImportExcel(file)}
                        customRenderer={(onClick: any, disabled: any) =>
                            <button className="btn btn-outline-dark w-150px px-0"
                                    onClick={onClick}
                                    disabled={disabled}>
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt=""/>엑셀 가져오기
                            </button>}
                        accept={".xlsx, .xls"}
                    />
                </AuthorityChecker>
                <button className="btn btn-dark w-150px px-0" onClick={btnExportExcel}>
                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt=""/>엑셀 내보내기
                </button>
                {/*<button className="btn btn-outline-primary ms-40px" onClick={btnGoToColumnSetting}>
                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_gear_blue.png"} alt=""/>컬럼 설정
                </button>*/}
            </div>
        </div>

        <div className="table_scroll overflow-x-scroll">
            <table className="table table-bordered my_table">
                <colgroup>
                    <col style={{width: "3%", minWidth: "60px"}}/>
                    {colRenderer()}
                </colgroup>
                <thead>
                <tr>
                    <th>
                        <div className="checkbox_outer">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isAllCheck}
                                onClick={clickAllCheck}
                            />
                        </div>
                    </th>
                    {thRenderer()}
                </tr>
                </thead>
                <tbody>
                {dataList.length !== 0
                    ? dataList.map((el, idx) =>
                        <tr className={`clickable ${selectedItem.includes(el.overseasId) ? "lightblue" : ""}`}
                            onClick={() => clickCheck(el.overseasId)}>
                            <td className="text-center">
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={selectedItem.includes(el.overseasId)}
                                    />
                                </div>
                            </td>
                            {tdRenderer(idx)}
                        </tr>
                    )
                    : <EmptyTableRow colSpan={hiddenColumnData.filter(el => el.isHidden === "N").length}/>
                }
                </tbody>
            </table>
        </div>

        <PaginationSub totalCount={totalCount}
                       currentPage={searchParam.pageNo}
                       onChangeCallback={(i) => setSearchParam({...searchParam, pageNo: i})}/>
    </div>
}